import { gql } from "@apollo/client";
import { INTERVIEW_QUESTION_AI_VIDEO_TASK_FIELDS } from "graphql/fragments";

const GET_INTERVIEW_QUESTION_AI_VIDEO_GENERATION_STATUS = gql`
  ${INTERVIEW_QUESTION_AI_VIDEO_TASK_FIELDS}
  query interviewQuestionAiVideoGenerationStatus($questionId: ID!) {
    interviewQuestionAiVideoGenerationStatus(questionId: $questionId) {
      ...InterviewQuestionAiVideoTaskFields
    }
  }
`;

export { GET_INTERVIEW_QUESTION_AI_VIDEO_GENERATION_STATUS };
